import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import CloseButton from '../../common/CloseButton/CloseButton';
import '../../common/CommonText.css';
import InputBoxLarge from '../../common/InputBox/InputBoxLarge';
import InputBoxSmall from '../../common/InputBox/InputBoxSmall';
import SelectBoxLarge from '../../common/SelectBox/SelectBoxLarge';
import SelectBoxSmall from '../../common/SelectBox/SelectBoxSmall';
import InputAndSelectCompoBoxSmall from '../../common/InputBox/InputAndSelectCompo';
import TextBox from '../../common/TextBox/TextBox';
import RichTextBox from '../../common/InputBox/RichTextBox'; // Import RichTextBox
import SearchSelectBoxDrown from '../../common/SelectBox/searchSelect';




const AddNotification = ({ isOpen, title, fields, onSave, onClose, popupErrorMessage }) => {
  const [formValues, setFormValues] = useState({});
  const [formErrors, setFormErrors] = useState({});


  if (!isOpen) return null;

  const handleInputChange = (field, value) => {
    setFormValues(prev => ({
      ...prev,
      [field]: value,
    }));
    
    // Clear error when field is modified
    if (formErrors[field]) {
      setFormErrors(prev => ({
        ...prev,
        [field]: null,
      }));
    }
  };

  const validateField = (field) => {
    const fieldValidators = field.validators || [];
    const value = formValues[field.name] || field.defaultValue || "";
    
    // Run all validators for the field
    for (const validator of fieldValidators) {
      const result = validator(value);
      if (typeof result === 'string') {
        return result; // Return the first error message
      }
    }
    
    return null; // No errors
  };

  const handleSubmit = (action) => {
    // Validate all fields
    const errors = {};
    let hasErrors = false;
    
    fields.forEach((field) => {
      if (!field.validators) return;
      
      const errorMessage = validateField(field);
      if (errorMessage) {
        errors[field.name] = errorMessage;
        hasErrors = true;
      }
    });
    
    // Update error state
    setFormErrors(errors);
    
    if (hasErrors) {
      console.error("Validation errors:", errors);
      return; // Prevent submission
    }
    
    onSave({ ...formValues, action });
  };


  const renderField = (field, index) => {
    const commonProps = {
      key: index,
      ...field,
      error: formErrors[field.name],
    };
    
    switch (field.type) {
      case 'small-input':
        return (
          <div key={index} className="field-container w-50">
            <InputBoxSmall
              {...commonProps}
              onChange={(e) => handleInputChange(field.name, e.target.value)}
              error={formErrors[field.name]}
            />
          </div>
        );
      case 'large-input':
        return (
          <div key={index} className="field-container w-100">
            <InputBoxLarge
              {...commonProps}
              onChange={(e) => handleInputChange(field.name, e.target.value)}
              error={formErrors[field.name]}
            />
          </div>
        );
      case 'large-select':
        return (
          <div key={index} className="field-container w-100">
            <SearchSelectBoxDrown
              {...commonProps}
              onChange={(e) => handleInputChange(field.name, e.target.value)}
              error={formErrors[field.name]}
            />
          </div>
        );
      case 'small-select':
        return (
          <div key={index} className="field-container w-50">
            <SearchSelectBoxDrown
              {...commonProps}
              className='w-48'
              onChange={(e) => handleInputChange(field.name, e.target.value)}
              error={formErrors[field.name]}
            />
          </div>
        );
      case 'input-select-combo-small':
        return (
          <div key={index} className="field-container w-50">
            <InputAndSelectCompoBoxSmall
              {...commonProps}
              onChange={(value) => handleInputChange(field.name, value)}
              error={formErrors[field.name]}
            />
          </div>
        );
      case 'text':
        return (
          <div key={index} className="field-container w-100">
            <TextBox
              {...commonProps}
              onChange={(e) => handleInputChange(field.name, e.target.value)}
              error={formErrors[field.name]}
            />
          </div>
        );
      case 'rich-text':
        return (
          <div key={index} className="field-container w-100">
            <RichTextBox
              {...commonProps}
              onChange={(value) => handleInputChange(field.name, value)}
              error={formErrors[field.name]}
            />
          </div>
        );
      case 'date':
      case 'time':
        return (
          <div key={index} className="field-container w-100">
            <InputBoxLarge
              {...commonProps}
              type={field.type}
              onChange={(e) => handleInputChange(field.name, e.target.value)}
              error={formErrors[field.name]}
            />
          </div>
        );
      case 'custom':
        return (
          <div key={index} className="field-container w-100 custom-field-container">
            {field.component({
              ...field,
              onChange: (value) => handleInputChange(field.name, value),
              error: formErrors[field.name]
            })}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="popup-overlay">
      <div className="popup add-popup popup1 ">
        <CloseButton onClick={onClose} />
        {popupErrorMessage && (
          <div className="popup-error-message fts-13" style={{ color: 'red', marginBottom: '10px' }}>
            {popupErrorMessage}
          </div>
        )}
        <div className="popup-name-button">
          <h2 className="popup-name fts-17 common-text ftw-5 black">{title}</h2>
          <div className='add-notification-buttons'>
            <button className="popup-add-button popup-shedule-button black fts-15" onClick={() => handleSubmit('schedule')}>
              Schedule Now
            </button>
            <button className="popup-add-button white fts-15" onClick={() => handleSubmit('send')}>
              Send Now
            </button>
          </div>
        </div>
        <div className="add-input-box-container">
          {fields.map((field, index) => renderField(field, index))}
        </div>
      </div>
    </div>
  );
};

AddNotification.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  buttonName: PropTypes.string,
  fields: PropTypes.array.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  popupErrorMessage: PropTypes.string
};

export default AddNotification;